import styled, { css } from "styled-components";
import { media } from "../../../../layouts/utils";

export const Container = styled.div`
  position: relative;
  padding: 1rem 1.5rem 5rem 1.5rem;
  background-color: #f7f7fc;
  ${media.phone`
    position: static;
  `}
`;

export const Title = styled.div`
  width: 100%;
  color: #230c87;
  font-family: "Galano Grotesque Alt";
  font-size: min(7vw, 3rem);
  letter-spacing: 0rem;
  line-height: 4.525rem;
  text-align: center;
  padding: 2rem 1.5rem 0;
  ${media.phone`
    padding: 0.5rem 1.5rem 0;
  `}
`;

export const ContainerPlan = styled.div`
  z-index: 1;
  margin: 0 60px;
  background: #fff;
  border-width: 2px;
  border-radius: 1rem;
  overflow: hidden;
  opacity: 1;
  padding: 32px 0;
  ${media.phone`
    margin: 0 10px;
  `}
`;

export const Sorriso = styled.div`
  width: 100%;
  height: 30px;
  background-image: ${(props) =>
    props.dark
      ? `url("/gwmbrasil/assets/img-simplifique2.png")`
      : `url("/gwmbrasil/assets/img-simplifique.png")`};
  background-repeat: no-repeat;
  background-position-x: center;
  margin-bottom: 20px;
`;

export const Plans = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  z-index: 5;
  @media (max-width: 768px) {
    overflow: scroll;
    justify-content: ${({ size }) => (size > 1 ? "initial" : "center")};
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Modal = styled.div`
  position: absolute;
  bottom: ${({ isError }) => (isError ? "5.65rem" : "6.25rem")};
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
  max-width: 37.5rem;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 2.25rem 2rem;
  border-radius: 1rem;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  display: ${({ open }) => (open ? "flex" : "none")};
  @media (max-width: 767px) {
    width: 90%;
    bottom: -18rem;
  }
  ${media.phone`
    z-index: 3;
	`}
`;
export const ModalTitle = styled.div`
  font-size: 2rem;
  font-family: "Galano Grotesque Alt";
  color: ${({ color }) => color};
  width: 100%;
  ${media.phone`
    line-height: 35px;

  `}
`;

export const ModalDescription = styled.div`
  width: 100%;
  font-size: 1rem;
`;

export const ModalInput = styled.input`
  width: 100%;
  height: 3.75rem;
  background: white;
  padding: 1rem;
  border-radius: 10px;
  border: none;
`;

export const ModalLinkContainer = styled.div`
  display: flex;
  width: 100%;
  padding: ${({ isError, isMobile }) =>
    isError ? "20px 0 0" : isMobile ? "0px" : "20px 0"};
`;

export const ModalLink = styled.b`
  margin-right: 8px;
  font-size: 16px;
  font-weight: normal;
  text-decoration: underline;
  color: #fff;
  cursor: pointer;
`;

export const ModalLinkContent = styled.div`
  display: flex;
`;

const buttonEnabled = css`
  cursor: pointer;
  color: ${({ color }) => color};
  &:hover {
    height: 4rem;
    //to balance new height colateral
    margin-bottom: -0.5rem;
    margin-right: -0.5rem;
    min-width: 9.25rem; // + .5em from default
    padding: 1.1rem 2.25rem;
    //to balance side padding collateral
    transform: translate(-0.25rem, -0.25rem);
  }
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ backgroundColor }) => backgroundColor} !important;
  color: ${({ color }) => color};
  opacity: 0.6;
`;

export const Button = styled.div`
  user-select: none;
  height: 3.5rem;
  min-width: 8.75rem;
  max-width: 12rem;
  padding: 0.9rem 2rem;
  font-family: "Galano Grotesque Alt";
  font-size: 1rem;
  transition: all 0.1s ease-in 0s;
  border-radius: 9999px;
  text-align: center;
  color: ${({ color }) => color};
  background: ${({ backgroundColor }) => backgroundColor};
  ${({ disabled }) => (disabled ? buttonDisabled : buttonEnabled)}
`;

export const ErrorText = styled.div`
  width: 100%;
  font-size: 0.9rem;
  font-family: "Galano Grotesque Alt";
`;

export const LoadingCupom = styled.img`
  width: 2rem;
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  box-shadow: none;
  pointer-events: ${({ disabled }) => disabled && "none"};
`;
